// extracted by mini-css-extract-plugin
module.exports = {"root":"dialogBox_root__1aCiW","root_open":"dialogBox_root_open__LYtVh","modal_content":"dialogBox_modal_content__dy7kl","downgrade_content":"dialogBox_downgrade_content__3lbyc"};